// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__76kNJ","sectionOverlay":"styles_sectionOverlay__TVB0M","component":"styles_component__PQAYC","columnGroup":"styles_columnGroup__6onux"};